<template>
    <div>
        <span data-locator="message" v-html="activity.message"></span>
        <relative-time data-locator="time" v-if="isToday" :timestamp="activity.timestamp"></relative-time>
        <span data-locator="time" v-else>{{ activity.created_at | formattedTime }}</span>
    </div>
</template>

<script>
import moment from 'moment'
import RelativeTime from '../Global/RelativeTime'

export default {
    props: {
        activity: {
            type: Object,
            required: true
        }
    },

    computed: {
        isToday () {
            return moment(this.activity.created_at, 'YYYY-MM-DD HH:mm:ss').isSame(new Date(), 'day')
        }
    },

    components: {
        RelativeTime
    }
}
</script>
